import { Component, OnInit } from '@angular/core';

import {ModuleService} from '../login/module.service';
import {Module} from '../login/module';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'pl-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.css']
})
export class ModulesComponent implements OnInit {

  modules : Module[];
  msgs: Message[];

  constructor(private moduleService: ModuleService) {
    this.modules = [];
    this.msgs = [];
   }

  ngOnInit() {
    this.moduleService.loadAvailableModules().subscribe(
      modList => {
        for(var mod of modList)
        {
          let module : Module = new Module();
          module.id = mod.id;
          module.name = mod.name;
          module.descr = mod.descr;
          module.link = mod.link;
          module.type = mod.type;
          module.active = mod.active;
          this.modules.push(module);
        }
      }
    );
  }

  public onChangeSwitch(e) {
    this.moduleService.saveModuleListActiveState(this.modules).subscribe(
      (res)=> {
        if(res.success){
          this.msgs = [];
          this.msgs.push({severity: 'info', summary: 'Gespeichert'});
        }else{
          this.msgs = [];
          this.msgs.push({severity: 'error', summary: 'Error', detail: 'Änderung konnte nicht gespeichert werden.'});
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/modules/modules.component.ts